import { forwardRef } from "react";
import classNames from "classnames";
import { Modal } from "antd";
import type { GetRef, ModalProps } from "antd";
import styles from "./styles.module.scss";

type ModalRef = GetRef<typeof Modal>;

export const AppModal = forwardRef<ModalRef, ModalProps>(({ className, ...props }, ref) => {
  return (
    <span ref={ref} className={styles.wrapper}>
      <Modal className={classNames(styles.comp, className)} {...props} />
    </span>
  );
});
